module.exports = __webpack_public_path__ + "static/media/logo.1aaf2c87.png";